import { ASSIGN_PHONE_ALREADY_SET_MESSAGE } from "../types";

export const getApiErrorMessageFromText = (value: string): string => {
  const normalizedValue = (value || "").trim();
  if (!normalizedValue) {
    return "";
  }

  try {
    const parsedValue = JSON.parse(normalizedValue) as
      | string
      | {
          detail?: unknown;
          message?: unknown;
          error?: unknown;
        };

    if (typeof parsedValue === "string") {
      return parsedValue.trim();
    }

    if (typeof parsedValue?.detail === "string") {
      return parsedValue.detail.trim();
    }

    if (typeof parsedValue?.message === "string") {
      return parsedValue.message.trim();
    }

    if (typeof parsedValue?.error === "string") {
      return parsedValue.error.trim();
    }
  } catch (error) {
    return normalizedValue;
  }

  return normalizedValue;
};

export const getHttpErrorStatus = (error: unknown): number | null => {
  if (!error || typeof error !== "object") {
    return null;
  }

  const status = (error as { status?: unknown }).status;
  return typeof status === "number" ? status : null;
};

export const getHttpErrorResponseText = (error: unknown): string => {
  if (!error || typeof error !== "object") {
    return "";
  }

  const responseText = (error as { responseText?: unknown }).responseText;
  return typeof responseText === "string" ? responseText : "";
};

export const toUserFacingErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  const responseMessage = getApiErrorMessageFromText(
    getHttpErrorResponseText(error),
  );
  if (responseMessage) {
    return responseMessage;
  }

  if (error instanceof Error) {
    const normalizedMessage = (error.message || "").trim();
    if (!normalizedMessage) {
      return fallback;
    }

    const separator = " - ";
    const separatorIndex = normalizedMessage.indexOf(separator);
    if (separatorIndex >= 0) {
      const rawTailMessage = normalizedMessage
        .slice(separatorIndex + separator.length)
        .trim();
      const parsedTailMessage = getApiErrorMessageFromText(rawTailMessage);
      if (parsedTailMessage) {
        return parsedTailMessage;
      }
    }

    return normalizedMessage;
  }

  return fallback;
};

export const isAssignPhoneAlreadySetConflict = (error: unknown): boolean => {
  if (getHttpErrorStatus(error) !== 400) {
    return false;
  }

  const responseText = getHttpErrorResponseText(error);
  const rawMessage = error instanceof Error ? error.message : "";

  return (
    responseText.includes(ASSIGN_PHONE_ALREADY_SET_MESSAGE) ||
    rawMessage.includes(ASSIGN_PHONE_ALREADY_SET_MESSAGE)
  );
};
